var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "87a8bdb86e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.515625 55 L 363 55 L 363 325 L 10.515625 325 Z M 10.515625 55 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "455b30c852"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 97.269531 192.648438 L 97.269531 345.8125 L 147.726562 375.015625 L 147.726562 221.851562 L 100.128906 194.304688 Z M 97.269531 192.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 225.789062 374.554688 L 274.339844 346.460938 L 274.339844 193.226562 L 225.789062 221.335938 Z M 225.789062 374.554688 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#87a8bdb86e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 338.054688 56.035156 L 187.226562 143.34375 L 36.046875 55.847656 L 35.820312 55.714844 L 35.304688 55.714844 L 10.628906 70 L 10.628906 295.664062 L 61.089844 324.878906 L 61.089844 129.660156 L 186.65625 202.332031 L 313.378906 128.988281 L 313.378906 323.871094 L 362.886719 295.210938 L 362.886719 70.398438 Z M 338.054688 56.035156 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 284.519531 25.042969 L 241.378906 0.078125 L 186.539062 31.8125 L 131.566406 0 L 87.035156 25.777344 L 185.148438 82.5625 Z M 284.519531 25.042969 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ee04966207096e3920d064c412901b7.svg";
export { ForwardRef as ReactComponent };